import { Box, Typography, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import SearchOffIcon from '@mui/icons-material/SearchOff';

interface IngredientRequestNoResultsProps {
  searchText: string;
  requestSubmitted: boolean;
  onSubmit: () => void;
}

const IngredientRequestNoResults: React.FC<IngredientRequestNoResultsProps> = ({
  searchText,
  requestSubmitted,
  onSubmit,
}) => {
  const theme = useTheme();
  const trimmed = searchText.trim();

  if (requestSubmitted) {
    return (
      <Box
        sx={{
          px: 1.5,
          py: 1.5,
          textAlign: 'center',
          maxWidth: { sm: 220 },
          mx: 'auto',
        }}
      >
        <CheckCircleOutlineIcon
          sx={{ fontSize: 28, color: 'success.main', mb: 0.5 }}
        />
        <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
          {`Thanks — we've logged "${trimmed}".`}
        </Typography>
        <Typography sx={{ fontSize: 12, color: 'text.secondary', mt: 0.25 }}>
          We review these regularly to decide what to add. Keep browsing in the
          meantime.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        px: 1.5,
        py: 1.5,
        textAlign: 'center',
        maxWidth: { sm: 220 },
        mx: 'auto',
      }}
    >
      <SearchOffIcon sx={{ fontSize: 28, color: 'text.disabled', mb: 0.5 }} />
      <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
        {`No match for “${trimmed}”`}
      </Typography>
      <Typography sx={{ fontSize: 12, color: 'text.secondary', mt: 0.25 }}>
        Don&apos;t see what you&apos;re avoiding? Let us know and we&apos;ll
        look at adding it.
      </Typography>
      <Box
        onClick={onSubmit}
        sx={{
          mt: 1.5,
          py: 1.25,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          width: '100%',
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          borderRadius: 2,
          cursor: 'pointer',
          fontSize: 13,
          fontWeight: 600,
        }}
      >
        <Box
          sx={{
            width: 22,
            height: 22,
            borderRadius: '50%',
            backgroundColor: theme.palette.primary.main,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <AddIcon sx={{ fontSize: 16 }} />
        </Box>
        {`Submit “${trimmed}”`}
      </Box>
    </Box>
  );
};

export default IngredientRequestNoResults;
